export const SURVEY_TYPE = 'costumerPortal';
